import * as TypeAction from './actionTypes'
import { TypeSucesso } from 'scorpion-core';

export const setAppBarValues = (values, retorno) => (dispatch) => {
    dispatch({ type: TypeSucesso(TypeAction.APPBAR), payload: values })
}

export const limpaAppBarValues = () => (dispatch) => {
    dispatch({ type: TypeSucesso(TypeAction.APPBAR), payload: {} })
}


// WEBPACK FOOTER //
// ./src/App/actions.js